<template>
  <q-card style="width: 600px; max-width: 60vw">
    <q-bar class="bg-primary text-white">
      <q-icon name="fas fa-keyboard" />
      <div>
        <small class="q-ml-sm text-size-sm">
          编辑
          <!-- {{ PdmBodycheckDaoruEntity.PdmBodycheckDaoruName }}({{
                            PdmBodycheckDaoruEntity.PdmBodycheckDaoruID
                        }}) -->
        </small>
      </div>

      <q-space />

      <q-btn dense flat icon="close" v-close-popup>
        <q-tooltip>关闭</q-tooltip>
      </q-btn>
    </q-bar>

    <q-card-section class="q-pa-sm">
      <div class="row q-gutter-sm q-mb-sm q-mr-sm">
        <q-input
          label="姓名"
          dense
          outlined
          class="col-2"
          v-model="PdmBodycheckDaoruEntity.Name"
        />

        <q-input
          label="证件号码"
          dense
          outlined
          class="col-4"
          v-model="PdmBodycheckDaoruEntity.CertNo"
        />
        <q-input
          label="电话号码"
          dense
          outlined
          class="col-3"
          v-model="PdmBodycheckDaoruEntity.Phone"
        />
        <q-btn-toggle
          v-model="PdmBodycheckDaoruEntity.Sex"
          push
          glossy
          toggle-color="primary"
          :options="[
            { label: '男', value: 1 },
            { label: '女', value: 2 },
          ]"
        />
        <q-input
          label="年龄"
          dense
          outlined
          class="col-2"
          v-model="PdmBodycheckDaoruEntity.Age"
        />
        <q-input
          label="学院"
          dense
          outlined
          class="col-9"
          v-model="PdmBodycheckDaoruEntity.XueYuan"
        />
      </div>
    </q-card-section>

    <q-card-actions align="right" class="bg-white text-teal">
      <q-btn flat label="取消" v-close-popup />
      <q-btn flat label="确定" @click="onOK" />
    </q-card-actions>
  </q-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  components: {},
  props: {},
  computed: {
    ...mapState("PdmBodycheckDaoru", [
      "PdmBodycheckDaoruShowDlg",
      "PdmBodycheckDaoruEntity",
      "PdmBodycheckDaoruList",
    ]),
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    ...mapActions("PdmBodycheckDaoru", [
      "actUpdatePdmBodycheckDaoru",
      "actGetPdmBodycheckDaoruList",
    ]),
    onOK() {
      this.actUpdatePdmBodycheckDaoru({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        Info: this.PdmBodycheckDaoruEntity,
      }).then((res) => {
        if (res.Code == 0) {
          this.$emit("onLoadData");
          this.msg.success(res.Message);
        } else {
          this.msg.error(res.Message);
        }
      });
    },
  },
};
</script>
